
import { ChangeTracked } from "./index";
import { PlanOption } from "./index";

export class PlanOptionRuleOption {
    planOptionRuleOptionId: number;
    planOptionRuleId: number;
    edhPlanOptionId: number;
    planOption: PlanOption & ChangeTracked<PlanOption>;
}
